<template>
  <div class="initialOrder" :class="{ 'no-product-section': noResultFound }">
  <div class="prdt-search" :class="{'open_modal':isSearchOpen}" :style="[
        $route.query.tab
          ? { top: '0px' }
          : { top: `${couponCardHeight+113}px` },
      ]">
      <span class="close-icon" @click="clearSearchText()">
        <CloseIcon />        
      </span>
      <input
        type="text"
        class="input-searchbg"
        placeholder="Search by keywords"
        v-on:keyup="searchProducts($event)"
        v-model="searchTerm"
      />
      <span class="search-icon" @click="goToSearchResult()" :class="{'visibilityHidden':!searchTerm.length}">
        <i class="material-icons">search</i>
      </span>
    </div>
  <h3 class="total-calc flx" v-if="products.length" style="display:flex">
      Total Products : {{ totalProductLength }}
      <span class="search-icon" @click="isSearchOpen = !isSearchOpen"><i class="material-icons">search</i></span>
    </h3>
    <div class="half-order-listings">
      <ul v-if="products.length">
        <li v-for="(product, index) in products" :key="index">
          <div class="prod-list">
            <span
              class="product-img"
              v-if="
                product.itemDTOList[0].itemMediaDTOList &&
                  product.itemDTOList[0].itemMediaDTOList.length
              "
              @click="goToProductDetail(product.itemDTOList[0].sellerItemRelationshipId)"
            >
              <img
                :src="product.itemDTOList[0].itemMediaDTOList[0].small"
                alt="product"
              />
            </span>
             <span
              class="product-img" v-else>
              <img
                src="../../assets/images/watermark1.jpg"
                alt="product"
              />
             </span>
            <div class="product-detail">
              <div @click="goToProductDetail(product.itemDTOList[0].sellerItemRelationshipId)">
                <h4>{{ product.itemDTOList[0].itemName }}</h4>
                <span
                  class="product-price"
                  v-if="!['INACTIVE', 'DELETED'].includes(product.itemDTOList[0].sellerItemStatus)"
                  ><span class="rupee-font">₹</span
                  >{{ product.itemDTOList[0].sellingPrice }}
                  <strike v-if="parseFloat(product.itemDTOList[0].sellingPrice) < parseFloat(product.itemDTOList[0].mrp)"
                    ><span class="rupee-font">₹</span
                    >{{ product.itemDTOList[0].mrp }}</strike
                  >
                </span>
                <span
                  class="product-price"
                  v-if="
                    product.itemDTOList[0].sellerItemStatus === 'INACTIVE' ||
                      product.itemDTOList[0].sellerItemStatus === 'DELETED'
                  "
                  ><span class="rupee-font">₹</span
                  >{{ product.itemDTOList[0].mrp }}
                </span>
                <p v-if="!['INACTIVE', 'DELETED', 'PENDING'].includes(product.itemDTOList[0].sellerItemStatus)">
                  Stock Quantity:
                  <span class="stock"
                    >{{ product.itemDTOList[0].quantity }} Stock Left</span
                  >
                </p>
                <span
                  class="item-oos"
                  v-if="product.itemDTOList[0].sellerItemStatus === 'INACTIVE'"
                >
                  out of stock
                </span>
                <span
                  class="item-oos"
                  v-if="['DELETED','UNAPPROVED'].includes(product.itemDTOList[0].sellerItemStatus)"
                >
                  {{product.itemDTOList[0].sellerItemStatus}}
                </span>
                <span
                  class="item-oos"
                  v-if="['PENDING'].includes(product.itemDTOList[0].sellerItemStatus)"
                >
                  Pending for Approval
                </span>
              </div>
            </div>

            <span
              class="material-icons more_optn"
              @click="openDialogue(index)"
              v-if="product.itemDTOList[0].sellerItemStatus !== 'DELETED' && !$route.query.CLOUDSHOP"
              >more_vert</span
            >
            <div class="openDialogue" v-if="isShow === index">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 23 23"
                @click="isShow = !isShow"
              >
                <path
                  fill="#CDCDCD"
                  fill-rule="nonzero"
                  d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                  opacity=".675"
                />
              </svg>
              <router-link
                :to="{ path: '/add-product?productId=' + product.productId + '&shopid=' + $route.query.shopid  }"
                tag="span" v-if="$route.query.shopid"
                >Edit</router-link
              >
              <router-link
                :to="{ path: '/add-product?productId=' + product.productId  }"
                tag="span" v-else
                >Edit</router-link
              >
              <span @click="openDeleteItem(index)" v-if="$route.query.shopid">Delete</span>
              <span
                @click="outOfStock('ACTIVE', product.productId, index)"
                v-if="product.itemDTOList[0].sellerItemStatus === 'INACTIVE'"
                >In Stock</span
              >
              <span
                @click="outOfStock('INACTIVE', product.productId, index)"
                v-if="product.itemDTOList[0].sellerItemStatus === 'ACTIVE'"
                >Out of Stock</span
              >
            </div>
            <div class="customModal" v-if="isDeleteBox === index">
              <div class="modal_dialog Cod" style="padding:0">
                <div class="modal_content" style="padding:15px">
                  <div class="modal_body padding0">
                    <p>{{ $t('doYouReallyWantToRemoveItem') }}</p>
                  </div>
                </div>
                <div class="modal_footer cod">
                  <button
                    type="button"
                    class="order_btn cancel"
                    @click="isDeleteBox = !isDeleteBox"
                  >
                    {{ $t('no') }}
                  </button>
                  <button
                    type="button"
                    class="order_btn order-now"
                    @click="deleteItem('DELETED', product.productId, index)"
                  >
                    {{ $t('yes') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <infinite-loading
        @infinite="getPreOrdersListing"
        spinner="circles"
        :class="{ visibilityHidden: noResultFound }"
        :identifier="resetIdentifier"
      >
        <template slot="no-more">{{ $t('noMoreRecord') }}</template>
      </infinite-loading>
    </div>
    <div class="no-product" v-if="noResultFound">
      <div class="no-item-found">
        <div class="img-block">
          <img src="../../assets/images/ic_product_box_add.svg" />
        </div>
        <div class="details-block">
          <p>{{$t('youHaveNotAddedProductsYet')}}</p>
          <!-- <button type="button" class="ad-product" @click="addProduct()">+ प्रोडक्ट जोड़े</button> -->
        </div>
      </div>
    </div>
    <!-- <div class="add-newprdtab" >
      <AddProductIconTab class="tab-bg" />
      <span class="tab-data" @click="openAddProductOptionModal">
        <PlusIcon />Suggest new Products
      </span>
    </div> -->
    <div class="add-newprdtab" v-if="$route.query.CLOUDSHOP" style="width:225px">
      <p style="visibility:hidden">
      <AddProductIconTab class="tab-bg" />
      </p>
      <span class="tab-data" style="background: green; width:250px;
    padding: 8px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;" @click="openSuggestModal =!openSuggestModal">
        <PlusIcon />Suggest new Products
      </span>
    </div>
    <div class="add-newprdtab" v-else>
      <AddProductIconTab class="tab-bg" />
      <span class="tab-data" @click="openAddProductOptionModal">
        <PlusIcon />{{$t('addNewProducts')}}
      </span>
    </div>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
    <AddProductSuggestModal v-if="openSuggestModal" @closeSuggestModal="openSuggestModal = !openSuggestModal" />
  </div>
</template>

<script>
import '../../assets/css/order-history.scss';
import InfiniteLoading from 'vue-infinite-loading';
import CustomToaster from '../../components/Common/CustomToaster';
import ApiCaller from '../../utils/apicaller';
import constant from '../../utils/constant';
import Vue from 'vue';
import PlusIcon from '@/components/Icons/PlusIcon';
import AddProductIconTab from '@/components/Icons/AddProductIconTab';
import CloseIcon from '@/components/Icons/CloseIcon';
import AddProductSuggestModal from '@/components/OrderHistorySection/AddProductSuggestModal'
Vue.use(InfiniteLoading);
export default {
  name: 'UserProduct',
  components: {
    InfiniteLoading,
    CustomToaster,
    AddProductIconTab,
    PlusIcon,
    CloseIcon,
    AddProductSuggestModal
  },
  data() {
    return {
      isSearchOpen:false,
      limit: 20,
      preOrderIndex: 0,
      orderLoading: false,
      products: [],
      preloader: true,
      isActive: false,
      isToasterData: false,
      isShow: false,
      isDeleteBox: false,
      noResultFound: false,
      resetIdentifier: +new Date(),
      loading: false,
      searchTerm: "",
      totalProductLength: '',
      tabStatus: 'seller_product',
      openSuggestModal: false
    };
  },
  props: {
    couponCardHeight: {

    }
  },
  methods: {
    clearSearchText() {
      this.isSearchOpen = false;
      if(this.searchTerm){
        this.searchTerm = "";
        this.preOrderIndex = 0
        this.products = []
        this.getPreOrdersListing()
      }
      
    },
    searchProducts(event) {
      if (
        event != null &&
        typeof event.keyCode != "undefined" &&
        event.keyCode == 13
      ) {
        this.searchTerm = event.target.value;
        this.preOrderIndex = 0
        this.products = []
        this.getPreOrdersListing()
      } else {
        this.searchTerm = event.target.value;
        this.preOrderIndex = 0
        this.products = []
        this.getPreOrdersListing()
      }
    },
    goToSearchResult(){
      this.preOrderIndex = 0
      this.products = []
      this.getPreOrdersListing()
    },
    openAddProductOptionModal() {
      try {
          JSBridgePlugin.fireEvents("ADD_PRODUCT_CLICK_LMALL");
        } catch (err) {
          console.log(err);
        }
      this.$emit('openAddProductOptionModal');
    },
    goToProductDetail(saleReferenceID) {
      // const _this = this;
      // this.$router.push("/detail/" + saleReferenceID);
    },
    openDialogue(index) {
      this.isShow = index;
    },
    openDeleteItem(index) {
      this.isShow = false;
      this.isDeleteBox = index;
    },
    outOfStock(value, id, index) {
      //  let disableItem = document.querySelectorAll('.prod-list');
      //     disableItem[index].classList.add('disable');       
      //   setTimeout(()=>{
      //    this.products = this.products.filter(it=>it.itemDTOList[0].productId!=id)
      //   },500) 
      // this.$store.commit('saveData', {
      //   preOrders: this.products.filter(it=>it.itemDTOList[0].productId!=id),
      //   preOrderIndex: this.preOrderIndex,
      //   type: 'myshop_order',
      // });
      this.loading = true
      this.isDeleteBox = false;
      const obj = {
        productId: id,
        status: value,
      };
      this.isShow = false;
      ApiCaller(
        constant.CATALOGUE_URL,
        'update-product-status',
        'post',
        obj
      ).then((data) => {
        (this.products = []), (this.preOrderIndex = 0);
        let disableItem = document.querySelectorAll('.prod-list');
        disableItem[index].classList.add('disable');
        this.loading = false;
        this.resetIdentifier += 1;
      });
    },
    addProduct() {
      this.$router.push('/add-product');
    },
    deleteItem(value, id, index) {
      let disableItem = document.querySelectorAll('.prod-list');
          disableItem[index].classList.add('disable');       
        setTimeout(()=>{
         this.products = this.products.filter(it=>it.itemDTOList[0].productId!=id)
        },500) 
      this.$store.commit('saveData', {
        preOrders: this.products.filter(it=>it.itemDTOList[0].productId!=id),
        preOrderIndex: this.preOrderIndex,
        type: 'myshop_order',
      });
      this.isShow = false;
      this.isDeleteBox = false;
      const obj = {
        productId: id,
        status: value,
        shopId: this.$route.query.shopid,
      };
      ApiCaller(
        constant.CATALOGUE_URL,
        'update-product-status',
        'post',
        obj
      ).then((data) => {
      });
    },
    getPreOrdersListing($state) {
      if (this.$cookie.get('X-Auth-Id') != null) {
        
        if(this.$route.query.shopid){
          const obj = {
            status: 'ACTIVE',
            pageIndex: this.preOrderIndex,
            searchTerm: this.searchTerm,
            sellerShopId: this.$route.query.shopid
          };
          ApiCaller(constant.CATALOGUE_URL, 'get-seller-product?shopid=' + this.$route.query.shopid, 'post', obj)
          .then((data) => {
            this.totalProductLength = data.data.totalProduct
            if(this.preOrderIndex == 0 && data.data && !data.data.productDTOs){
                this.products = []
            }else 
             if (
              data.data &&
              data.data.productDTOs &&
              data.data.productDTOs.length > 0
            ) {
              // this.products = []
              this.products.push(...data.data.productDTOs);
              this.preOrderIndex += 1;
              this.$store.commit('saveData', {
                preOrders: this.products,
                preOrderIndex: this.preOrderIndex,
                type: 'myshop_order',
              });
              this.$emit('productListLength', true)
              this.noResultFound = false;
              $state && $state.loaded();
            } else {
              $state && $state.complete();
            }
            if (this.products.length == 0) {
              this.noResultFound = true;
            }
          })
          .catch((err) => {});
        }else{
          const obj = {
            status: 'ACTIVE',
            pageIndex: this.preOrderIndex,
            searchTerm: this.searchTerm,
          };
          ApiCaller(constant.CATALOGUE_URL, 'get-seller-product', 'post', obj)
            .then((data) => {
              this.totalProductLength = data.data.totalProduct
              if(this.preOrderIndex == 0 && data.data && !data.data.productDTOs){
                  this.products = []
              }else 
              if (
                data.data &&
                data.data.productDTOs &&
                data.data.productDTOs.length > 0
              ) {
                // this.products = []
                this.products.push(...data.data.productDTOs);
                this.preOrderIndex += 1;
                this.$store.commit('saveData', {
                  preOrders: this.products,
                  preOrderIndex: this.preOrderIndex + 1,
                  type: 'myshop_order',
                });
                this.$emit('productListLength', true)
                this.noResultFound = false;
                $state && $state.loaded();
              } else {
                $state && $state.complete();
              }
              if (this.products.length == 0) {
                this.noResultFound = true;
              }
            })
            .catch((err) => {});
        }
      }
    },
    goPayToPaytm(id) {
      this.$router.push('/pay-to-paytm/' + id);
    },
  },
  mounted() {
    if(this.$store.getters.preOrders &&
      this.$store.getters.preOrders.length > 0 &&
      this.$store.getters.preOrderIndex){
        this.products = this.$store.getters.preOrders;
        this.preOrderIndex = this.$store.getters.preOrderIndex;
      }
    // if (this.$store.getters.preOrders.length > 0) {
    //   this.products = this.$store.getters.preOrders;
    //   this.preOrderIndex = this.$store.getters.preOrderIndex;
    // }
  },
};
</script>
<style lang="scss" scoped>
.navlisttab {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .navlisttab li {
      width: auto;
      padding: 8px;
      background: #fff;
      color: #727272;
      border: 1px solid #727272;
      font-size: 14px;
      border-radius: 8px;
      transition: all ease 0.3s;
      position: relative;
    }

    .navlisttab li.selected-tab {
      background: #ff9933;
      border: 1px solid #ff9933;
      color: #fff;
      z-index: 1;
    }

    .navlisttab li:first-child {
      padding-right: 16px;
    }

    .navlisttab li:last-child {
      padding-left: 16px;
    }

    .navlisttab li:first-child.selected-tab {
      padding-right: 8px;
      left: 8px;
    }

    .navlisttab li:last-child.selected-tab {
      padding-left: 8px;
      left: -8px;
    }
.paytm-button {
  border: 0;
  background: none;
  color: #0278ff;
  font-weight: 500;
  font-size: 0.8em;
  text-shadow: 0px 0px 1px #0278ff;
  font-family: 'Roboto', sans-serif;
}
.prod-list {
  // background-color: #ffffff;
  padding: 8px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
  margin: 0 0 8px 0;
  border-radius: 4px;
  &.disable {
    animation: linear fadeout 0.5s 1;
    @keyframes fadeout {
      0% {
        opacity: 1;
      }
      50% {
        height: 0.5;
      }
      100% {
        opacity: 0;
      }
    }
  }
}
.visibilityHidden {
  visibility: hidden;
}
</style>
